import restClient from "../restClient";

export const getUserDefineds = async () => {
  try {
    const token = localStorage.getItem('token');
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
    const response = await restClient.get(`user-defineds`,config);
    return response.data;
  } catch (err) {
    console.log(err);
    throw err;
  }
};

export const updateUserDefineds = async (id, data) => {
  try {
    const token = localStorage.getItem('token');
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
    const response = await restClient.put(`user-defineds/${id}`, { data: data }, config);
    return response.data;
  } catch (err) {
    console.log(err);
    throw err;
  }
};
